// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M10.55 1.76l1.72.58a3.7 3.7 0 012.53 3.5V8.3h3.87a3 3 0 012.96 3.46l-1.18 7.7A3 3 0 0117.48 22H2V10.1h4.85l3.7-8.34zM6.5 12.1H4V20h2.5v-7.9zm2 7.9h8.98a1 1 0 001-.85l1.18-7.7a1 1 0 00-1-1.15H12.8V5.85a1.7 1.7 0 00-1.15-1.61L8.5 11.3V20z"}}]};

const ThumbUp2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'thumb-up-2',
    ref,
    icon: element,
  },
));

ThumbUp2Icon.displayName = 'ThumbUp2Icon';

export default ThumbUp2Icon;
